var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLitterExpenses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_expenses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.47,
    y: 1.59,
    width: 521.46,
    height: 597.98,
    rx: 51.27,
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 74.18,
    width: 363.95,
    height: 147.6,
    rx: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 298,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 298,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 443.57,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.08,
    y: 298,
    width: 72.79,
    height: 218.37,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 443.57,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterExpenses);
export default __webpack_public_path__ + "static/media/litter_expenses.8caa6772d3979799d6809983418a5f72.svg";
export { ForwardRef as ReactComponent };